import React from 'react';
import './Sidebar.css';

interface SidebarProps {
  activeSection: string;
  onSectionChange: (section: string) => void;
  userName: string;
  onLogout: () => void;
  collapsed?: boolean;
  onToggle?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ activeSection, onSectionChange, userName, onLogout, collapsed = false, onToggle }) => {
  const allMenuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '🏠' },
    { id: 'cadastro', label: 'Ficha MCMV', icon: '📝' },
    { id: 'meus-cadastros', label: 'Meus Cadastros', icon: '📋' },
    { id: 'documentos', label: 'Documentos', icon: '📄' },
    { id: 'perfil', label: 'Meu Perfil', icon: '👤' }
  ];

  // Para usuários inscritos, mostrar apenas a Ficha MCMV
  const menuItems = allMenuItems.filter(item => item.id === 'cadastro');

  return (
    <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <h2>Portal MCMV</h2>
        {onToggle && (
          <button className="sidebar-toggle" onClick={onToggle} aria-label={collapsed ? 'Mostrar menu' : 'Ocultar menu'}>
            {collapsed ? '☰ Mostrar menu' : '✕ Ocultar'}
          </button>
        )}
        <div className="user-info">
          <span className="user-name">{userName}</span>
          <span className="user-type">Inscrito</span>
        </div>
      </div>
      
      <nav className="sidebar-nav">
        <ul>
          {menuItems.map((item) => (
            <li key={item.id}>
              <button
                className={`nav-item ${activeSection === item.id ? 'active' : ''}`}
                onClick={() => onSectionChange(item.id)}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-label">{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>
      
      <div className="sidebar-footer">
        <button className="logout-btn" onClick={onLogout}>
          <span className="nav-icon">🚪</span>
          <span className="nav-label">Sair</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;